const CLEANUP_KEY = "__tornarSliderCleanup__";
const DISTANCIA_MINIMA_ARRASTE = 8;
const SELETOR_ELEMENTOS_INTERATIVOS = [
  "input",
  "textarea",
  "select",
  "button",
  "a",
  "label",
  "[contenteditable='true']",
  "[data-no-drag-slider='true']",
].join(", ");

export default function tornarSlider(containerPai) {
  const slider = containerPai;
  if (!slider) return () => {};

  if (typeof slider[CLEANUP_KEY] === "function") {
    slider[CLEANUP_KEY]();
  }

  let pressionado = false;
  let arrastando = false;
  let posicaoInicialX = 0;
  let posicaoInicialY = 0;
  let scrollInicialX = 0;
  let scrollInicialY = 0;
  let bodyUserSelectAnterior = "";
  let bodyCursorAnterior = "";

  const limparEstadoDeArraste = () => {
    if (arrastando) {
      document.body.style.userSelect = bodyUserSelectAnterior;
      document.body.style.cursor = bodyCursorAnterior;
    }

    pressionado = false;
    arrastando = false;
    slider.classList.remove("active");
  };

  const onMouseUp = () => {
    limparEstadoDeArraste();
  };

  const onMouseMove = (e) => {
    if (!pressionado) return;

    const deltaX = e.pageX - posicaoInicialX;
    const deltaY = e.pageY - posicaoInicialY;

    if (!arrastando) {
      const distanciaPercorrida = Math.max(Math.abs(deltaX), Math.abs(deltaY));

      if (distanciaPercorrida < DISTANCIA_MINIMA_ARRASTE) return;

      const selecaoAtual = window.getSelection?.();
      if (selecaoAtual && !selecaoAtual.isCollapsed) {
        limparEstadoDeArraste();
        return;
      }

      arrastando = true;
      slider.classList.add("active");
      bodyUserSelectAnterior = document.body.style.userSelect;
      bodyCursorAnterior = document.body.style.cursor;
      document.body.style.userSelect = "none";
      document.body.style.cursor = "grabbing";
    }

    e.preventDefault();
    slider.scrollLeft = scrollInicialX - deltaX * 2;
    slider.scrollTop = scrollInicialY - deltaY * 2;
  };

  const onMouseDown = (e) => {
    if (e.button !== 0) return;
    if (e.target.closest(SELETOR_ELEMENTOS_INTERATIVOS)) return;

    pressionado = true;
    posicaoInicialX = e.pageX;
    posicaoInicialY = e.pageY;
    scrollInicialX = slider.scrollLeft;
    scrollInicialY = slider.scrollTop;
  };

  const onMouseLeave = () => {
    if (!arrastando) return;
    limparEstadoDeArraste();
  };

  slider.addEventListener("mousedown", onMouseDown);
  slider.addEventListener("mouseleave", onMouseLeave);
  document.addEventListener("mousemove", onMouseMove);
  document.addEventListener("mouseup", onMouseUp);

  const cleanup = () => {
    slider.removeEventListener("mousedown", onMouseDown);
    slider.removeEventListener("mouseleave", onMouseLeave);
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
    limparEstadoDeArraste();

    if (slider[CLEANUP_KEY] === cleanup) {
      delete slider[CLEANUP_KEY];
    }
  };

  slider[CLEANUP_KEY] = cleanup;

  return cleanup;
}
